/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listNotificationPoliciesParamsQueryMax = 100;

export const listNotificationPoliciesParamsLimitOneRegExp = new RegExp(
  '^(?:0*(?:[1-9][0-9]?|100))$',
);
export const listNotificationPoliciesParamsLimitTwoMax = 100;

export const listNotificationPoliciesParamsLimitDefault = 50;
export const listNotificationPoliciesParamsCursorMax = 2000;

export const ListNotificationPoliciesParams = zod.object({
  query: zod.string().max(listNotificationPoliciesParamsQueryMax).optional(),
  limit: zod
    .union([
      zod.string().regex(listNotificationPoliciesParamsLimitOneRegExp),
      zod.int().min(1).max(listNotificationPoliciesParamsLimitTwoMax),
    ])
    .default(listNotificationPoliciesParamsLimitDefault),
  cursor: zod.string().min(1).max(listNotificationPoliciesParamsCursorMax).optional(),
});

export type ListNotificationPoliciesParams = zod.input<typeof ListNotificationPoliciesParams>;
export type ListNotificationPoliciesParamsOutput = zod.output<
  typeof ListNotificationPoliciesParams
>;
